import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import rootReducer from './rootReducer';

export const configureStore = () => {
  const oldStore: AppState = readStateFromLocalStorage();

  const store = createStore(
    rootReducer,
    oldStore,
    composeWithDevTools(applyMiddleware(thunk))
  );

  return store;
};

const readFromLocalStorage = (name: string) => {
  const str = localStorage.getItem(name);
  const result = str ? JSON.parse(str) : null;
  return result;
}

const readStateFromLocalStorage = () => {
  const state = readFromLocalStorage('state') || {};
  return state as AppState;
}

export const saveToLocalStorage = (store: BasicStore) => {
  const { assets, debts, burnRate } = store.getState();
  localStorage.setItem('state', JSON.stringify({ assets, debts, burnRate }));
}

interface BasicStore {
  getState: Function,
}
export type AppState = ReturnType<typeof rootReducer>;
